import { nanoid } from 'nanoid'

export function genGapFillingId() {
  return nanoid(16)
}
